import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  purchaseOrderBreadcrumb: {
    defaultMessage: 'Purchase orders',
    id: 'tNpowJ',
    description: 'Purchase orders page header',
  },
  purchaseOrder: {
    defaultMessage: '>> PO: {orderId}',
    id: 'LbQAV3',
    description: 'Purchase order id breadcrumb',
  },
});
